export default "/list/static/images/logo-expedia-2023.svg";